﻿import { mapGetters, mapState } from 'vuex';
import errorMessage from './errorMessage.vue';

export default {
    name: 'ca-customer-order-info',
    props: ['viewmodel', 'editmode', 'viewusecashflag', 'viewusecashonlymessage', 'viewmincreditpayment'],
    components: {
        'ca-error-message': errorMessage
    },
    data: () => ({
        tangoCOurl: '',
        tango4Durl: ''
    }),

    methods: {
        getQueryString: function (field, url) {
            const href = url ? url : window.location.href;
            const reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
            const string = reg.exec(href);
            return string ? string[1] : null;
        },
        getOrder: function (orderGuid) {
            this.$store.dispatch('getOrder', {
                'orderGuid': orderGuid,
                'context': 'payment',
                'preAuthLoaderTitle': this.viewmodel.getPreAuthLoaderTitle,
                'preAuthLoaderMessage': this.viewmodel.getPreAuthLoaderMessage,
                'getOrderLoaderTitle': this.viewmodel.getOrderLoaderTitle,
                'getOrderLoaderMessage': this.viewmodel.getOrderLoaderMessage,
                'loaderTitle': this.viewmodel.getCreditCheckLoaderTitle,
                'loaderMessage': this.viewmodel.getCreditCheckLoaderMessage,
                'getOrderLoaderMessage': this.viewmodel.getOrderLoaderMessage,
                'useCashOnlyFlowFlag': this.viewusecashflag,
                'minCreditPayment': this.viewmincreditpayment
            });
        },
        checkCustomerWantsCA: function (e) {
            if (e.target.checked) {
                if (this.order && !this.order.useNewDiva) {
                    this.$store.dispatch('getPreAuth', {
                        'loaderTitle': this.viewmodel.getPreAuthLoaderTitle,
                        'loaderMessage': this.viewmodel.getPreAuthLoaderMessage
                    });
                }
                document.getElementById('cbCustomerWantsCA').disabled = true;
            } else {
                for (let i = 0; i < this.creditAgreement.subscriptionAgreementItems.length; i++) {
                    if (this.creditAgreement.subscriptionAgreementItems[i].hardwarePaymentId > 0) {
                        this.$store.dispatch('deleteHardwarePayment', this.creditAgreement.subscriptionAgreementItems[i]);
                    }
                };

                this.$store.dispatch('updateOrder', { 'context': 'creditPaymentConsent', 'answer': e.target.checked });
            }
            this.$store.dispatch('changeCreditAgreementSelected');
        },
        checkCustomerWantsJoiceCA: function () {
            this.$store.dispatch('getJoiceCreditCheck', {
                'loaderTitle': this.viewmodel.getCreditCheckLoaderTitle,
                'loaderMessage': this.viewmodel.getCreditCheckLoaderMessage
            });
        }

    },
    created: function () {
        const self = this;
        if (!this.editmode) {
            const orderGuid = this.getQueryString('guid');
            this.tangoUrl = this.getQueryString('host');
            this.getOrder(orderGuid);

            this.$store.dispatch('setTexts', {
                'getOrder': this.viewmodel.getOrderErrorMessage,
                'orderState': this.viewmodel.orderStateErrorMessage,
                'preAuthBlocked': this.viewmodel.preAuthCustomerBlockedErrorMessage,
                'preAuthExpired': this.viewmodel.preAuthOrderExpiredErrorMessage,
                'preAuthGeneral': this.viewmodel.preAuthGeneralErrorMessage,
                'preAuthData': this.viewmodel.preAuthDataErrorMessage,
                'updateOrder': this.viewmodel.updateOrderErrorMessage,
                'getOrderUpdates': this.viewmodel.getOrderUpdatesErrorMessage,
                'downPaymentPlan': this.viewmodel.downPaymentPlanErrorMessage,
                'getDiscountDetails': this.viewmodel.getDiscountDetailsErrorMessage,
                'joiceOrderRejected': this.viewmodel.joiceOrderRejectedErrorMessage,
                'joiceCreditCheckData': this.viewmodel.joiceDataErrorMessage,
                'creditCheck': this.viewmodel.updateOrderErrorMessage,
                'joiceOrderRetry': this.viewmodel.JoiceOrderRetryErrorMessage,
            });

            this.$store.dispatch('setConstants', {
                'returnLabelMaterialIds': this.viewmodel.returnLabelMaterialIds
            });

            this.$store.watch(state => state.creditaccount.orderStored, (newState) => {
                if (self.paymentMethod !== 'pbs') {
                    document.getElementById('cbCustomerWantsCA').disabled = true;
                }
                else {
                    document.getElementById('cbCustomerWantsCA').checked = self.customerWantsCreditAgreement;
                    if (self.customerWantsCreditAgreement) {
                        if (!self.order.useNewDiva) {
                            this.$store.dispatch('getDownPaymentPlan');
                        }
                    }
                    if ((!self.order.useNewDiva && self.viewusecashflag) ||
                        (self.order.useNewDiva &&
                        (self.creditAgreement.totalCredit === 0 ? self.creditAgreement.payNow : self.creditAgreement.totalCredit) < self.viewmincreditpayment)) {
                        this.$store.dispatch('setCreditCheckValid', true);
                    }
                    else {
                        this.$store.dispatch('setCreditCheckValid', false);
                    }


                }
            });

            this.$store.watch(state => state.creditaccount.inErrorState, (newErrors, oldErrors) => {
                var childNodes = document.getElementById("xwing").getElementsByTagName('*');
                for (var i = 0; i < childNodes.length; i++) {
                    if (childNodes[i].id === "pageNavigationCreditAccount") {
                        break;
                    }
                    childNodes[i].disabled = true;
                }
            });
        }
    },
    computed:
        Object.assign(
            mapState({
                order: state => state.creditaccount.order,
                customerWantsCreditAgreement: state => state.creditaccount.customerWantsCreditAgreement,
                isSuccessful: state => state.creditaccount.isSuccessful,
                preAuth: state => state.creditaccount.preAuth,
                existingAgreement: state => state.creditaccount.existingAgreement,
                creditAgreement: state => state.creditaccount.creditAgreement,
                contracts: state => state.creditaccount.contracts,
                warnings: state => state.creditaccount.warnings,
                pageLoader: state => state.creditaccount.pageLoader,
                paymentMethod: state => state.creditaccount.paymentMethod,
                joiceCreditCheck: state => state.creditaccount.joiceCreditCheck,
                isCreditCheckValid: state => state.creditaccount.isCreditCheckValid,

            }),
            mapGetters({
                orderPersonAddressStreet: 'orderPersonAddressStreet',
                orderPersonAddressCity: 'orderPersonAddressCity',
                orderTotalPrice: 'orderTotalPrice',
                currency: 'currency'
            }),
            {
                orderPersonName: function () {
                    if (this.order.orderer)
                        return this.order.orderer.person.name.firstName + " " + this.order.orderer.person.name.lastName;
                    else return "";
                }
            }
        )
}